import React from 'react'
import SendIcon from '../icons/SendIcon'

type SubmitButtonProps = {
    text: string,
    imDisabled: boolean
}

const SubmitButton = ({text, imDisabled}: SubmitButtonProps) => {

    let buttonStyle ='flex flex-row-reverse items-center gap-2 px-3 py-2 transition-slow group md:py-2 md:px-4';
    buttonStyle += imDisabled ? ' text-para-1 bg-toto-0' : ' text-kaho-1 bg-toto-0 hover:bg-toto-1 hover:scale-105';

    return (
        <button type='submit' className={buttonStyle}>
            <SendIcon style={'size-4 group-hover:translate-x-0.5 transition-slow'} />
            <span className='-translate-y-px'>{text}</span>
        </button>
    )
}

export default SubmitButton
